export default {
  actions:{
    buy:'إشترى',
    cancel:'إلغاء',
    book:'احجز اﻵن',
    reserve: 'احجز اﻵن',
    
  },
  label:{
    price:'السعر',
    afterDiscount:'بعد التخفيض',
    color:'اللون',
    qty:'الكميه',
    desc:'الوصف',
    speci:'المواصفات',
    video:'مشاهده الفيديو',
    readmore:'المزيد',
    showless:'اخفاء',
    choose:'اختر من اﻵتى:',
    submit:'إرسال',
    deliverTime:'اختر وقت التوصيل',
    selectArea:'أختر منطقه',
    selectCity:'أختر مدينه',
    select:'أختر'


  },
  images:{
    noImages:'لا يوجد صور'
  },
  tableLabels:{
    ar: [
      {
        key: "name",
        label: "المواصفات"
      },
      {
        key: "value",
        label: ""
      }
  ],
  },
  orderCart: {
    label: "تعديل الطلب",
    remove: "حذف",
    increase: "+",
    decrease: "-",
    addProduct: " اضف المزيد",
    confirm: "ارسال الطلب",
    cancel:"خروج",
    subtotal: "التكلفة",
    tax: "تكاليف الضريبة",
    delivery: "تكاليف التوصيل",
    total: " التكلفة النهائية",
    discount: "الخصم",
    note: "ملحوظات:",
    empty_order: "حقيبه مشترياتك اﻵن فارغه !",
    zero: 0.00,
    edit:'تعديل',
    delete:'حذف',
    noItem:'لا يوجد بضائع فى حقيبتك !',
    browsing:'ابدأ التصفح'
  },
  notify:{
    errorInput:"حدث خطأ, يجب إدخال رقم اللون" ,
    confirmErr:"عفوا❗ لم تطلب شيئ بعد",
    error:"حدث خطأ حاول مره ثانية",
    emptyList:"عربة الطلب فارغة!",
    largeFile: "File is too large!",
    maxSize: "Maximum size is",
    support: "file is not supported!",
    uploadError : "File could not be uploaded for some reason, Please try again.",
    multiFilesUpload: "Can't upload more ",
    multiFiles: " files at a time!",
    noInternet : "حدث خطا ف الاتصال"
  }
  ,
  placeHolder:{
    input:"ادخل ",
    messageInput: "...اكتب الرسالة "
  },
  captureLead:{
    phoneValidation:'رقم هاتف خطأ',
    emailValidation: 'ايميل خطأ',
    hello: "أهلًا بك!"
  },
  footer: { 
    poweredBy: "Powered by"
  },
  chatBody: {
    typingIndicator: "...البوت يفكر ",
  },
};
